export const chapters = [
  {
    id: 11,
    part: 1,
    englishTitle: "Sasuke Rescue Mission",
    kanjiTitle: "tbd",
    romanizedTitle: "tbd",
    available: false,
    parts: [
        {
            englishTitle: "Infertile Fields",
            label: "tbd", 
            available: false,
            content: `Content for Infertile Fields...`
        },
        {
            englishTitle: "The Year-Long Mission",
            label: "tbd", 
            available: false,
            content: `Content for The Year-Long Mission...`
        },
        {
            englishTitle: "Sasuke Rescue Mission",
            label: "tbd", 
            available: false,
            content: `Content for Sasuke Rescue Mission...`
        },
        {
            englishTitle: "Uzumaki Naruto vs Uchiha Sasuke",
            label: "tbd", 
            available: false,
            content: `Content for Uzumaki Naruto vs Uchiha Sasuke...`
        }
    ]
  }
];